/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "risk": {
                        "nested": {
                          "CheckDepositRiskDecision": {
                            "values": {
                              "RISK_DECISION_UNKNOWN": 0,
                              "RISK_DECISION_APPROVE": 1,
                              "RISK_DECISION_APPROVE_FUNDING_INSTANT_FULL": 7,
                              "RISK_DECISION_APPROVE_FUNDING_INSTANT_PARTIAL": 8,
                              "RISK_DECISION_APPROVE_HOLD": 3,
                              "RISK_DECISION_APPROVE_HOLD_DAYS_5": 5,
                              "RISK_DECISION_APPROVE_HOLD_DAYS_7": 6,
                              "RISK_DECISION_DECLINE": 2,
                              "RISK_DECISION_MANUAL_REVIEW": 4
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.risk?.nested?.CheckDepositRiskDecision) {
  $root.addJSON(jsonData);
}

/**
 * next id: 9
 *
 * SOURCE CheckDepositRiskDecision @ squareup/cash/gambit/api/v1/risk/risk_decision.proto at 8:1
 */
export const CheckDepositRiskDecision = $root.lookupEnum('squareup.cash.gambit.api.v1.risk.CheckDepositRiskDecision').values;